import HomepageDispatcher from '../dispatcher/dispatcher'
import ActionTypes from '../constants/Action-Types'
import { urlCreator } from 'flodash'
import { RECENT_SEARCH_HELPER } from '../utils/recent-searches'
import isEmpty from 'lodash/isEmpty'
import * as PCLNAnalytics from '../utils/PCLN-Analytics'
import {
  ANALYTICS_CATEGORY,
  DATE_FORMAT
} from '../../common/constants/Constants'
import moment from 'moment'
import ajax from '../utils/ajax'
import * as FlightSearchFormUtils from '../utils/flight-search-form-utils'
import { path } from 'ramda'
const config = require('isomorphic-config')

const AIR_NEARBY_AIRPORTS_ENDPOINT = config.client.flights.nearbyAirports

export default {
  getNearestAirport (lat, lon) {
    return ajax({
      url: AIR_NEARBY_AIRPORTS_ENDPOINT,
      type: 'post',
      data: {
        airNearByAirportsReq: {
          latitude: lat,
          longitude: lon
        }
      }
    })
  },

  addMultiDestFlight (data) {
    HomepageDispatcher.dispatch({
      type: ActionTypes.FLIGHT_ADD_MULTI,
      data
    })
  },

  removeMultiDestFlight () {
    HomepageDispatcher.dispatch({
      type: ActionTypes.FLIGHT_REMOVE_MULTI
    })
  },

  updateFlight (id, data) {
    HomepageDispatcher.dispatch({
      type: ActionTypes.FLIGHT_UPDATE,
      flightId: id,
      data
    })
  },

  updateNearByAirports (nearByAirports = {}, label) {
    HomepageDispatcher.dispatch({
      type: ActionTypes.FLIGHT_NEARBY_AIRPORT,
      nearByAirports,
      label
    })
  },

  searchRetail (request, isNewForm = false) {
    // TODO: The ternary expression with the .mapNewFormSubmission can be retired,
    //       when new form is used by Hotels Home (/home/hotels/),
    //       VP Home (/home/vacationpackages/) & Home (/home/)
    const formRequest = isNewForm
      ? FlightSearchFormUtils.mapNewFormSubmission(request)
      : request

    // Store the recent search for the user
    RECENT_SEARCH_HELPER.saveFlightSearch(formRequest)

    const deepLinkUrl = __buildRedirect(formRequest)

    if (deepLinkUrl) {
      window.open(deepLinkUrl, '_blank')
    }
  },

  searchSOPQ (request, isNewForm = false) {
    // TODO: The ternary expression with the .mapNewFormSubmission can be retired,
    //       when new form is used by Hotels Home (/home/hotels/),
    //       VP Home (/home/vacationpackages/) & Home (/home/)

    // TODO: Use "productType" instead if the "isSOPQ" from the request data by form submission in home-components
    const isSOPQ = true
    const formRequest = isNewForm
      ? FlightSearchFormUtils.mapNewFormSubmission(request, isSOPQ)
      : request

    const redirectUrl = __buildRedirect(formRequest, true)
    window.open(redirectUrl, '_blank')
  }
}

function __buildSlices (request, isNoDateSearchVariant) {
  let flight

  let slices

  let departDate

  let returnDate

  switch (request.tripType) {
    case 'OW':
      flight = request.oneWayFlight

      departDate = moment(flight.departureDate).format(DATE_FORMAT)

      slices = [
        {
          origAirport: flight.departureLocation.id,
          destAirport: flight.arrivalLocation.id,
          origAirportType:
            flight.departureLocation.lat && flight.departureLocation.long
              ? '0'
              : '1',
          destAirportType:
            flight.arrivalLocation.lat && flight.arrivalLocation.long
              ? '0'
              : '1',
          departDate: departDate
        }
      ]

      break
    case 'RT':
      flight = request.roundTripFlight

      departDate = moment(flight.departureDate).format(DATE_FORMAT)
      returnDate = moment(flight.returnDate).format(DATE_FORMAT)

      slices = [
        {
          origAirport: flight.departureLocation.id,
          destAirport: flight.arrivalLocation.id,
          origAirportType:
            flight.departureLocation.lat && flight.departureLocation.long
              ? '0'
              : '1',
          destAirportType:
            flight.arrivalLocation.lat && flight.arrivalLocation.long
              ? '0'
              : '1',
          departDate: departDate
        },
        {
          origAirport: flight.arrivalLocation.id,
          destAirport: flight.departureLocation.id,
          origAirportType:
            flight.arrivalLocation.lat && flight.arrivalLocation.long
              ? '0'
              : '1',
          destAirportType:
            flight.departureLocation.lat && flight.departureLocation.long
              ? '0'
              : '1',
          departDate: returnDate
        }
      ]

      break
    case 'MD':
      slices = request.multiDestFlights.map(flight => {
        return {
          origAirport: flight.departureLocation.id,
          destAirport: flight.arrivalLocation.id,
          origAirportType:
            flight.departureLocation.lat && flight.departureLocation.long
              ? '0'
              : '1',
          destAirportType:
            flight.arrivalLocation.lat && flight.arrivalLocation.long
              ? '0'
              : '1',
          departDate: moment(flight.departureDate).format(DATE_FORMAT)
        }
      })

      break
    default:
      break
  }

  return slices
}

function __buildRedirect (request, sopq) {
  let isNoDateSearch = false

  const options = {
    slices: __buildSlices(request) || [],
    totalPassengers: request.adultCount + request.childCount,
    params: {
      'cabin-class': request.cabinClass,
      'no-date-search': isNoDateSearch
    },
    mListings: !sopq,
    dealsUrl: sopq,
    asUrl: false
  }

  let searchType = ''
  options.slices.forEach(slice => {
    searchType += slice.origAirportType + slice.destAirportType
  })
  options.params['search-type'] = searchType

  if (request.adultCount) {
    options.params['num-adults'] = request.adultCount
  }

  if (request.youthsCount) {
    options.params['num-youths'] = request.youthsCount
  }

  if (request.childCount) {
    options.params['num-children'] = request.childCount
  }

  if (request.infantCount) {
    options.params['num-infants'] = request.infantCount
  }

  const refClickId = path(['PCLN_BOOTSTRAP_DATA', 'referral', 'clickId'], window)
  if (refClickId) {
    options.params['refclickid'] = refClickId
    options['refclickid'] = refClickId
  }

  if (!isEmpty(request.nearByAirports)) {
    if (request.nearByAirports.from) {
      const primaryAirport = request.nearByAirports.from.shift()
      if (primaryAirport === request.roundTripFlight.departureLocation.id) {
        __addGaForNearby('From', request.nearByAirports.from.length)
        options.params['near-by-origin'] =
          request.nearByAirports.from.toString().replace(/,/g, '-')
      } else {
        __addGaForNearby('From')
      }
    } else {
      __addGaForNearby('From')
    }
    if (request.nearByAirports.to) {
      const primaryAirport = request.nearByAirports.to.shift()
      if (primaryAirport === request.roundTripFlight.arrivalLocation.id) {
        __addGaForNearby('To', request.nearByAirports.to.length)
        options.params['near-by-dest'] =
          request.nearByAirports.to.toString().replace(/,/g, '-')
      } else {
        __addGaForNearby('To')
      }
    } else {
      __addGaForNearby('To')
    }
  } else {
    __addGaForNearby('From')
    __addGaForNearby('To')
  }

  return urlCreator(options)
}

function __addGaForNearby (label, nearByCount) {
  return PCLNAnalytics.send({
    category: ANALYTICS_CATEGORY,
    action: 'Flight Search',
    data: `${label}_Select_Nearby-${nearByCount || 0}`
  })
}
